exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bg-custom{background-color:#00bcd4;box-shadow:2px 0 5px 0 rgba(0,0,0,.5)}nav .a-style{color:#fff;padding-right:10px}nav ul li{padding:0 5px;cursor:pointer}nav ul li .dropdown-toggle:after{border-top:.8em solid;border-right:.6em solid transparent;border-left:.6em solid transparent}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/components/header/_header.scss
// module id = ./node_modules/css-loader/index.js!./node_modules/sass-loader/lib/loader.js!./src/components/header/_header.scss
// module chunks = 0